jQuery(document).ready(function ($) {
    if($('.ChallengeSolution-wrapper').length){
        function flipMe(){
            $('.ChallengeSolution-card_item .ChallengeSolution-card_item_front').click(function(){
                console.log('mmm')
                $(this).css({
                    opacity: 0
                })
                $(this).siblings('.ChallengeSolution-card_item_back').css({
                    opacity: 1
                })
            })
            $('.ChallengeSolution-card_item .ChallengeSolution-card_item_back').click(function(e){
                var url = $(this).attr('data-url');
                e.preventDefault();
                if(url) {
                    if($(window).width() < 1024){
                        if (!$(this).hasClass('click-two')) {
                            $(this).addClass('click-two');
                            //toggle the menu 
                        } else {
                            //redirect if second click 
                            window.location = url;
                        }
                    } else {
                        window.location = url;
                    }
                }
               
//                     $(this).css({
//                         opacity: 0
//                     })
//                     $(this).siblings('.ChallengeSolution-card_item_front').css({
//                         opacity: 1
//                     })
            })
        }
        
        var to = true,
        throttle = function(func, delay){
            if (to) {
                window.clearTimeout(to);
            }
            to = window.setTimeout(func, delay);
        };
        

        $(window).on('load resize', function(){
            throttle(function(){
                flipMe();
            },150);
        });
        
        
    }
});
